/**
 * Events page: the event list filters, the recordings show-all toggle and the
 * past events toggle (the same show-all behaviour with every row behind it).
 *
 * The server renders every event and every recording, and renders the chips
 * and the toggle hidden, so without JS everything reads in full. This shows
 * the controls and makes them work.
 */

function initFilters() {
	document.querySelectorAll('[data-awdd-event-filters]').forEach((filters) => {
		const list = filters.parentElement && filters.parentElement.querySelector('[data-awdd-event-list]');
		if (!list) return;

		const empty = filters.parentElement.querySelector('[data-awdd-event-empty]');
		const councilChips = Array.from(filters.querySelectorAll('[data-awdd-filter-council]'));
		const onlineChips = Array.from(filters.querySelectorAll('[data-awdd-filter-online]'));
		const items = Array.from(list.children).filter((el) => el.tagName === 'LI');
		if (!items.length) return;

		const pressed = (chips, attr, fallback) => {
			const on = chips.find((c) => c.getAttribute('aria-pressed') === 'true');
			return on ? on.getAttribute(attr) : fallback;
		};

		const apply = () => {
			const council = pressed(councilChips, 'data-awdd-filter-council', '');
			const online = pressed(onlineChips, 'data-awdd-filter-online', 'all');
			items.forEach((li) => {
				const slugs = (li.getAttribute('data-councils') || '').split(/\s+/).filter(Boolean);
				const councilOk = council === '' || !slugs.length || slugs.includes(council);
				const onlineOk = online !== 'online' || li.getAttribute('data-online') === '1';
				li.hidden = !(councilOk && onlineOk);
			});
			if (empty) empty.hidden = items.some((li) => !li.hidden);
		};

		const group = (chips) => {
			chips.forEach((chip) => {
				chip.addEventListener('click', () => {
					chips.forEach((c) => c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'));
					apply();
				});
			});
		};

		group(councilChips);
		group(onlineChips);
		filters.hidden = false;
		apply();
	});
}

function initRecordings() {
	document.querySelectorAll('[data-awdd-recordings-toggle], [data-awdd-show-toggle]').forEach((toggle) => {
		const list = document.getElementById(toggle.getAttribute('aria-controls') || '');
		if (!list) return;
		const extras = Array.from(list.querySelectorAll('[data-awdd-extra]'));
		if (!extras.length) return;

		const label = toggle.querySelector('[data-label]');
		const iconClosed = toggle.querySelector('[data-when="closed"]');
		const iconOpen = toggle.querySelector('[data-when="open"]');

		const set = (open) => {
			toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
			extras.forEach((li) => { li.hidden = !open; });
			// Only the label's own span changes, so the icons stay in place.
			if (label) {
				label.textContent = toggle.getAttribute(open ? 'data-show-fewer' : 'data-show-all') || label.textContent;
			}
			if (iconClosed) iconClosed.toggleAttribute('hidden', open);
			if (iconOpen) iconOpen.toggleAttribute('hidden', !open);
		};

		toggle.addEventListener('click', () => set(toggle.getAttribute('aria-expanded') !== 'true'));
		set(false);
		toggle.hidden = false;
	});
}

export default function initEvents() {
	initFilters();
	initRecordings();
}
